import { auth } from './app/auth.js';
import { loadTableAssets } from './components/features/app-table/tableLoader.js';
import { preloadSheets } from './app/utils/styleCache.js';

async function bootstrap() {
    const authResult = await auth();

    if (!authResult) {
        console.error("App-Start abgebrochen");
        return;
    }

    preloadSheets([
        'components/shared/app-card/app-card.css',
        'components/shared/app-filter/app-filter.css',
        'components/layout/app-header/app-header.css',
        'components/layout/app-sidebar/app-sidebar.css',
        'components/features/app-dialog/app-dialog.css',
        'components/features/app-summary/app-summary.css',
        'components/shared/app-input/app-input.css',
        'components/features/app-time/app-time.css',
        'components/features/app-table/style/tabulator.css',
        'components/features/app-table/style/customTabulator.css',
        'components/features/app-panel-list/app-panel-list.css',
        'components/features/app-panel-detail/app-panel-detail.css',
        'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css',
        'https://cdn.jsdelivr.net/npm/tom-select@2.5.2/dist/css/tom-select.css',
    ]);

    const externalAssets = loadTableAssets();

    await Promise.all([
        import('./components/layout/app-header/app-header.js'),
        import('./components/layout/app-sidebar/app-sidebar.js'),
        externalAssets,
        import('./components/features/app-table/app-table.js'),
        import('./components/features/app-dialog/app-dialog.js'),
        import('./components/features/app-time/app-time.js'),
        import('./components/shared/app-card/app-card.js'),
        import('./components/shared/app-filter/app-filter.js'),
        import('./components/shared/app-input/app-input.js'),
        import('./components/features/app-summary/app-summary.js'),
        import('./components/features/app-panel-list/app-panel-list.js'),
        import('./components/features/app-panel-detail/app-panel-detail.js'),
        import('./app/viewManager.js')
    ]);

    const { checkCurrentView } = await import('./app/viewManager.js');
    checkCurrentView();
}

bootstrap();